<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      fixed
      temporary
    >
      <div class="ma-2">
        <v-btn
          id="drawer-close"
          icon
          style="float: right"
          @click="drawer = false"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <div style="clear: both" />
      </div>
      <v-divider />
      <v-list
        flat
        dense
      >
        <v-list-item
          v-for="(item, i) in items.filter(value => value.show)"
          :id="item.id"
          :key="i"
          :to="item.to"
          link
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      color="primary"
      fixed
      dark
    >
      <v-app-bar-nav-icon
        id="app-bar-button-drawer"
        @click.stop="drawer = !drawer"
      />
      <v-toolbar-title>
        <router-link
          to="/"
          style="color: white; text-decoration: none"
        >
          <v-icon style="margin-bottom: 3px;">
            mdi-home
          </v-icon>
          Suspicious Activity
        </router-link>
      </v-toolbar-title>
      <v-spacer />
      <v-btn
        id="app-bar-button-to-adminportal"
        color="secondary"
        style="color: rgba(0, 0, 0, 0.87)"
        class="mr-2"
        :href="adminPortalUrl"
      >
        <v-icon>mdi-chevron-left</v-icon>
        Admin Portal
      </v-btn>
      <v-btn
        id="app-bar-button-logout"
        color="secondary"
        style="color: rgba(0, 0, 0, 0.87)"
        @click="logout"
      >
        <v-icon>mdi-logout</v-icon>
        Logout
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
  import { Routes } from '../router'
  import auth from '../auth/auth'
  import { api } from '../http/api'

  export default {
    name: 'AppHeader',

    data: () => ({
      drawer: false,
      adminPortalUrl: '#',
    }),

    computed: {
      items: () => {
        return [
          {
            icon: 'mdi-plus',
            title: Routes.NEW_RULE,
            to: { name: Routes.NEW_RULE },
            id: 'drawer-new-rule',
            show: auth.canAdd(),
          },
          {
            icon: 'mdi-view-list',
            title: Routes.RULE_LIST,
            to: { name: Routes.RULE_LIST },
            id: 'drawer-rule-list',
            show: auth.canView(),
          },
          {
            icon: 'mdi-history',
            title: Routes.AUDIT_LOG,
            to: { name: Routes.AUDIT_LOG },
            id: 'drawer-audit-log',
            show: auth.canView(),
          },
          {
            icon: 'mdi-file-chart',
            title: Routes.DETECTION_REPORT,
            to: { name: Routes.DETECTION_REPORT },
            id: 'drawer-detection-report',
            show: auth.canView(),
          },
        ]
      },
    },

    mounted () {
      api.getConfig().then((config) => {
        this.adminPortalUrl = config.adminPortalUrl
      })
    },

    methods: {
      logout () {
        auth.logout()
      },
    },
  }
</script>

<style scoped>

</style>
